import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar
} from '@ionic/react'
import { home } from 'ionicons/icons'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from "react-router"
import NiceDate from '../components/nice.date'
import Note from "../components/note"
import { State } from '../store'
import { checkAllEntries, checkAllEntriesType } from '../store/history'

interface StateProps {
  list: any[]
}

interface DispatchProps {
  checkAllEntries: checkAllEntriesType
}

type Props = RouteComponentProps<{}> & StateProps & DispatchProps

const List: React.FC<Props> = (props) => {
  const [showTest, setShowTest] = React.useState(false)
  const [toast, setToast] = useState<string>('');

  React.useEffect(() => {
    props.checkAllEntries()
  }, [])

  return (
    <IonPage color={'primary'}>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/home' })}>
              <IonIcon slot="icon-only" icon={home} />
            </IonButton>
          </IonButtons>
          <IonTitle>Eigenheim Versicherung</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        className="ion-padding"
        color={'background'}
      >
        <IonToast
          isOpen={Boolean(toast)}
          color={'warning'}
          onDidDismiss={() => setToast('')}
          message={toast}
          duration={1500}
        />

        <Note>
          Hier sind deine Geschäftsfälle die du aus der App gestartet hast aufgelistet
        </Note>

        <IonList>
          {props.list.map(entry => (
            <IonItem key={entry.id} button onClick={() => props.history.push({ pathname: '/list/' + entry.id })} detail>
              <IonLabel>
                <h2>GF: {entry.gf}</h2>
                <p>vom <NiceDate time={entry.created} /></p>
              </IonLabel>
            </IonItem>
          ))}
        </IonList>


        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10000,
          textAlign: 'center',
          padding: 16,
        }}>
          &copy; {new Date().getFullYear()}
        </div>

      </IonContent>
    </IonPage>
  );
};

export default connect<StateProps, DispatchProps, unknown, State>(
  ({history}) => ({
    list: Object.values(history.list).filter((e) => e.gf)
  }),
  {
    checkAllEntries
  }
)(List);
